import { ApolloClient } from 'apollo-client';
import { createHttpLink } from 'apollo-link-http';
import { setContext } from 'apollo-link-context';
import { InMemoryCache } from 'apollo-cache-inmemory';

const httpLink = createHttpLink({
  uri: `${process.env.REACT_APP_HTTP_PROTOCOL}://${process.env.REACT_APP_GRAPHQL_URI}/graphql`,
});

const authLink = setContext((_: any, { headers }: any) => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const token = urlParams.get('token');
  const sessionId = urlParams.get('sessionId');

  return {
    headers: {
      ...headers,
      'X-Treelab-Session-ID': sessionId,
      authorization: token ? `Bearer ${token}` : '',
    },
  };
});

export const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});
